import { createApp } from 'vue';
import { Quasar } from 'quasar';

import App from './App.vue';
import router from './router';
import pinia from './store';
import i18n from './i18n';
import quasarUserOptions from './quasar';
import { asset } from '@/utils/asset';
import './vee-validate';
import './registerServiceWorker';

const app = createApp(App);
app.config.globalProperties.$asset = asset;
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(Quasar, quasarUserOptions);
app.mount('#app');
